import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('Modal', {
  OPEN_FULLSCREEN_OVERLAY: null,
  CLOSE_FULLSCREEN_OVERLAY: null
});
